import React, { useState, useEffect } from "react";
import { Table, Space, Button, Row, Col, Input, Select, Card, Divider, Modal, } from "antd";
import { EyeOutlined, SearchOutlined, EditOutlined, DeleteOutlined, } from "@ant-design/icons";
import { customerService, vehicleService } from "../../../services";
import { Link, useNavigate, useParams } from "react-router-dom";
import { changeDocumentTitle } from "../../../utils/title";

const { Meta } = Card;

const NA = <span style={{ color: "#9ca3af", fontStyle: 'italic', letterSpacing: "0.5px" }}>N/A</span>

function ViewCustomer() {
  const { id } = useParams();
  const [isModalshow, setIsModalShow] = useState(false)
  const navigate = useNavigate()
  const [loading, setLoading] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, total: 0, pageSize: 10, });
  const [customer, setCustomer] = useState([]);
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "9",
      label: "9",
    },
  ];

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Status",
      dataIndex: "car_status",
      key: "car_status",
      render: (text) => text.toUpperCase()
    },
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
    },
    {
      title: "Vehicle",
      dataIndex: "vehicle",
      key: "vehicle",
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Chassis Number",
      dataIndex: "chasis_no",
      key: "chasis_no",
    },
    {
      title: "Tracking Number",
      dataIndex: "tracking_no",
      key: "tracking_no",
    },
    {
      title: "File Ref No",
      dataIndex: "file_ref",
      key: "file_ref",
    },
    {
      title: "Action",
      key: "Action",
      render: (text, record, { _id }) => (
        <Space size="small">
          <Link to={`/vehicle/edit/${record.id}`}>
            {/* <Button type="primary" size="small"> */}
            <EditOutlined />
            {/* </Button> */}
          </Link>

          <Link to={`/vehicle/${record.id}`}>
            {/* <Button type="primary" size="small"> */}
            <EyeOutlined />
            {/* </Button> */}
          </Link>

          {/* <Button type="primary" size="small" > */}
          <DeleteOutlined onClick={() => showModal(record.id)} />
          {/* </Button> */}
        </Space>
      ),
    },
  ];

  const showModal = (id) => {
    setSelectedDeleteRecord(id)
    setIsModalShow(true)
  }

  const handleCancel = () => {
    setIsModalShow(false)
  };

  const handleDelete = async () => {
    setDeleteLoading(true)
    const response = await vehicleService.deleteVehicle(selectedDeleteRecord);
    setDeleteLoading(false)
    if (response.success) {
      setVehicles((prevData) => prevData.filter((item) => item.id !== selectedDeleteRecord));
    }
    setIsModalShow(false);
  }


  const initialize = async (page = 1, pageSize = pagination.current) => {
    setLoading(true);
    const { success, data } = await customerService.view(id, page);
    setLoading(false);
    if (success) {
      setVehicles(data.vehicles.data);
      setPagination((prev) => ({
        ...prev,
        total: data.vehicles.total,
        current: page,
        pageSize,
      }));
      setCustomer({
        id: data.customer.id || NA,
        name: data.customer.name || NA,
        email: data.customer.email || NA,
        phone: data.customer.phone || NA,
        address: data.customer.address?.toUpperCase() || NA,
        town: data.customer.town?.toUpperCase() || NA,
        city: data.customer.city?.toUpperCase() || NA,
        country: data.customer.country?.toUpperCase() || NA,
      });
    }
  };

  useEffect(() => {
    changeDocumentTitle("View Customer");
    initialize();
  }, [])

  return (
    <>
      <Row gutter={24} wrap={false}>
        {/* First Column */}
        <Col flex="310px">
          <Card style={{ padding: "5px" }}>
            {/* First Section: Name and Email */}
            <Meta title={customer?.name} style={{ textAlign: "center" }} />
            <div style={{ marginTop: "10px", textAlign: "center" }}>
              <p> {customer.email}</p>
            </div>
            <Divider />
            <div className="profile-info">
              <div className="profile-item"><strong>Phone:</strong> <span>{customer?.phone}</span></div>
              <div className="profile-item"><strong>Address:</strong> <span>{customer?.address}</span></div>
              <div className="profile-item"><strong>Town:</strong> <span>{customer?.town}</span></div>
              <div className="profile-item"><strong>City:</strong> <span>{customer?.city}</span></div>
              <div className="profile-item"><strong>Country:</strong> <span>{customer?.country}</span></div>
            </div>
            <Divider />
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px" }} >

              <Button type="primary" size="small" onClick={() => navigate(`/operations/customer/form/${id}`)}>
                <EditOutlined />
              </Button>
            </div>
          </Card>
        </Col>
        {/* Second Column */}
        <Col flex="1">
          <div
            style={{
              padding: "15px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <Row gutter={12}>
              <Col span={12}>
                <h1 style={{ fontWeight: "bold" }}>Customer Vehicles</h1>
              </Col>
            </Row>
            <Row
              gutter={8}
              style={{
                marginTop: "15px",
                background: "#F2F2F7",
                padding: "5px",
                alignItems: "center", // Ensures alignment of items within the row
              }}
            >
              <Col
                span={4}
                xs={24}
                sm={12}
                md={6}
                lg={4}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Space direction="horizontal" size={10}>
                  <p style={{ margin: 0 }}>Show</p>
                  <Select
                    defaultValue={10}
                    options={options}
                    size="small"
                    style={{ width: 70, fontSize: 14 }}
                  />
                  <p style={{ margin: 0 }}>entries</p>
                </Space>
              </Col>

              {/* Second Column: Right-Aligned Search */}
              <Col
                span={20}
                xs={24}
                sm={12}
                md={18}
                lg={20}
                style={{
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Input
                  placeholder="Search"
                  prefix={<SearchOutlined />}
                  style={{
                    width: "30%",
                    borderRadius: "4px",
                    fontSize: 14,
                  }}
                />
              </Col>
            </Row>
            <Table
              columns={columns}
              scroll={{ x: "max-content" }}
              dataSource={vehicles}
              pagination={true}
              loading={loading}
              style={{ marginTop: "10px" }}
            />
          </div>
        </Col>
      </Row>


      <Modal
        title={<div style={{ textAlign: 'center' }}>Confirm</div>}
        open={isModalshow}
        onOk={handleDelete}
        onCancel={handleCancel}
        centered
        styles={{
          body: {
            padding: "20px",

          }
        }}
        width={300}
        footer={
          <div className='flex justify-center gap-3'>
            <Button type="default" onClick={handleCancel} style={{ width: "30%" }}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleDelete} loading={deleteLoading}>
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: 'center' }}>Are you sure you want to delete this?</p>
      </Modal>
    </>
  );
}
export default ViewCustomer;
